jQuery( document ).ready( function ( $ ) {
	if( $(".block-service-checkerboard" ).length ) {
		let checkerboardElements = document.querySelectorAll('.block-service-checkerboard .container *');
		function onEntry(entry) {
			entry.forEach(change => {
				if (change.isIntersecting) {
					change.target.classList.add('element-show');
				}
			});
		}

		let options = {
			root: null,
			rootMargin: '300px',
			threshold: .5
		};

		let observer = new IntersectionObserver(onEntry, options);

		for (let elm of checkerboardElements) {
			observer.observe(elm);
		}
	}
})
